export const filterByGenre = (videos, selectedGenre) => {
  let filteredVideos = []

  filteredVideos = videos.filter((video) => {
    const inGenre = video.genres.some((genre) => {
      return genre.name.toUpperCase() === selectedGenre.toUpperCase()
    })

    return inGenre
  })

  return filteredVideos
}

export const filterByCollection = (videos, collectionId) => {
  let filtered = []
  let collectionName = null

  filtered = videos.filter((video, index) => {
    let inCollection = false

    Object.values(video).forEach((prop, index) => {
      const isArray = Array.isArray(prop)

      if (isArray) {
        if (!inCollection) {
          inCollection = prop.some((entry) => {
            const id = entry.id.toUpperCase()
            const name = entry.name.replace(' ', '-').toUpperCase()
            const compare = collectionId.toUpperCase()

            const isInCollection = id === compare || name === compare

            const collection = Object.keys(video)[index]

            if (isInCollection) {
              if (collection.toUpperCase() === 'Brands'.toUpperCase()) {
                collectionName = `${entry.name}`
              } else if (collection.toUpperCase() === 'Directors'.toUpperCase()) {
                collectionName = `${entry.name}`
              } else if (collection.toUpperCase() === 'Skaters'.toUpperCase()) {
                collectionName = `${entry.name}`
              } else {
                collectionName = entry.name
              }
            }

            return isInCollection
          })
        }
      }
    })

    return inCollection
  })

  return {
    name: collectionName,
    videos: filtered,
  }
}

export const filterByFeatured = (videos) => {
  let filteredVideos = []

  filteredVideos = videos.filter((video) => {
    let isFeatured = false

    if (video.featured) {
      const featured = video.featured.toUpperCase()
      const compare = 'Yes'.toUpperCase()

      isFeatured = (featured === compare)
    }

    return isFeatured
  })

  return filteredVideos[0]
}



// WEBPACK FOOTER //
// ./src/common/contentful/lib/filters.js